import React from "react";
import CDLEImage from "../images/2024CDLEBANNER.png";

const Redirect = () => {
     setTimeout(function () {
        window.location.href =
          "https://cdlewbt116.cdle.state.co.us/physicians/";
      }, 5000);
      
    return(
          <main>
      <div class="redirect-box">
        <h2>You are being redirected...</h2>
        <p>
          The Accredited Provider Directory you are trying to access has moved.
        </p>
        <p>
          You will be redirected to the new page in <strong>5 seconds</strong>.
        </p>
        <a href="https://cdlewbt116.cdle.state.co.us/physicians/"
          >Click here if you are not redirected</a
        >
      </div>
    </main>
    );
};
export default Redirect;